
const cachedData: Record<string, object> = {

    "foo": { "one": 1 },
}

export default cachedData